export const DATA_5 = {
    name: '孤獨感',
    tabs: [
        {
            name: '報章評論',
            url: 'https://news.example.com/family-loneliness-hk',
            contents: [
                {
                    type: 'image',
                    src: '/secondary/tasks/C1-P1-banner.png',
                },
                                {
                    type: 'html',
                    html: `<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;孤獨是一個全球性的問題，而香港的情況尤其值得關注。以往人們談及孤獨，往往會想到獨居或缺乏照顧的長者。實際上，不少與家人同住的成年人同樣會感到與身邊的人缺乏聯繫。
                    <br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;香港家庭福利會一項調查顯示，本港約每五名與家人同住的人中，就有一人感到孤獨。調查估計，約有52萬名家庭成員會選擇自我封閉，不願向親友傾訴，甚至不願向人工智能（AI）聊天機器人尋求意見。香港家庭福利會高級經理張詠珊形容，這些人雖然並非獨居，但「每個人都像一座孤島」。
                    <br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在被列為感到孤獨的受訪者中，超過一半表示，他們經常因家庭關係而感到壓力，甚至希望逃離家庭。原本最親近的家人理應提供陪伴與支持，但不少人卻在日常相處中逐漸與家人疏遠。現代人生活忙碌，即使同住一個屋簷下，也可能各自投入自己的生活，彼此之間的交流愈來愈少。
                    <br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;要改善家庭中的孤獨問題，可先從增加相處時間和改善溝通做起。調查結果顯示，較多日常互動與較高的家庭幸福感相關。香港家庭福利會建議，家庭成員應增加日常相處和交談的時間。然而在現實生活中，部分家庭成員長時間沉浸在各自的數碼世界，面對面交流的機會可能因而減少。因此，政府應加強支援，善用人工智能協助促進人際互動，避免科技成為彼此疏遠的原因。
                    <br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;家庭成員除了需要多花時間陪伴彼此，也應在交流時表現出同理心和尊重。雖然在生活壓力沉重的環境下，要做到這些並不一定容易。對居住空間狹小的家庭而言，長時間共處甚至可能帶來更多摩擦。
                    <br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;較令人鼓舞的是，最新調查顯示香港整體家庭幸福指數輕微回升。但數字有所改善，並不代表問題已經解決。那些即使每天與家人生活在一起，仍然感到孤單的人，尤其值得關注。建立更緊密、和諧的家庭關係，不僅有助於減輕孤獨感，也能促進社會整體幸福感的提高。
                    <br/><br/><div class='w-full flex justify-center items-end flex flex-col' style='margin-top: 6px; font-weight: 300;'>資料來源：改編自《南華早報》</div><br/>`,
                }
            ]
        },
        {
            name: '科普文章',
            url: 'https://science.example.com/shared-meals-wellbeing',
            contents: [
                {
                    type: 'html',
                    html: `
                    <div class='w-full font-bold text-white flex flex-row items-center' style='background-color: #3F96FD; padding: 16px; gap:16px;'>
                    一起吃飯，與幸福感和孤獨感有關嗎？
                    </div>
                    <br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;以往，健康、財富水平等因素被視為決定幸福感的關鍵，《世界幸福報告2025》首次跳出這一傳統認知，將「與人共餐」等社會因素納入討論範疇。研究邀請來自142個國家和地區、超過15萬名受訪者回答過去一星期與認識的人共進了多少次午餐或晚餐，並為自己的生活狀況評分。
                    <br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;結果顯示，共同進餐的次數與生活評分之間存在明顯的關聯：整體而言，一週內共餐次數愈多的人，對生活的評價通常愈高。不過，共餐次數極少的受訪者之間，評分差異並不明顯；只有當共餐次數達到一定水平後，生活評分才隨次數增加而逐步上升。
                    <br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;對進餐次數和孤獨感的調查則顯示，與他人共同進餐次數較多的人通常較少感到孤獨。但研究人員亦指出，這種現象可能是因為原本生活較幸福、社交關係較好的人，本身便較常與別人一起吃飯。
                    <br/><br/>`,
                },
                {
                    type: 'title',
                    text: '圖1：昨天有很強烈孤獨感的受訪者百分比',
                },
               
                {
                    type: 'html',
                    html: `<div style='display:flex; flex-direction: column; align-items: center; width: 100%;'><img class='w-full' src='/secondary/tasks/C1-P2-img.png' style='max-width: 800px; height: auto;'/></div>`,
                },
                
                {
                    type: 'html',
                    html: `<div class='w-full flex justify-center items-center flex flex-col' style='margin-top: 6px; font-weight: 300;'>
                                註：孤獨感以0至1的量表衡量；數據來自13個國家2023年的調查（n = 6,375）。
                            </div>`,
                },
                {
                    type: 'html',
                    html: `<div class='w-full flex justify-center items-end flex flex-col' style='margin-top: 6px; font-weight: 300;'>
                                資料來源：《世界幸福報告2025》
                            </div>`,
                },
                {
                    type: 'title',
                    text: '表1：部分亞洲地區每週與他人共餐情況',
                },
                {
                    type: 'html',
                    html: `
<table class='w-full' style='border: 1px solid #9CB8D3;'>
  <tr>
    <th class='text-center w-[33%]' style='background-color: #EDF5F8; border: 1px solid #9CB8D3;'>國家／地區</th>
    <th class='text-center w-[33%]' style='background-color: #EDF5F8; border: 1px solid #9CB8D3;'>晚餐</th>
    <th class='text-center w-[33%]' style='background-color: #EDF5F8; border: 1px solid #9CB8D3;'>午餐</th>
  </tr>
  <tr>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>臺灣</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>5.5</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>4.7</td>
  </tr>
  <tr>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>香港</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>4.4</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>3.6</td>
  </tr>
  <tr>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>韓國</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>1.6</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>2.7</td>
  </tr>
  <tr>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>日本</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>1.8</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>1.9</td>
  </tr>
</table>
`,
                },
                {
                    type: 'html',
                    html: `<div class='w-full flex justify-center items-center flex flex-col' style='margin-top: 6px; font-weight: 300;'>
                                註：數字表示受訪者過去一星期平均與認識的人共同進餐的次數。
                            </div>`,
                },
                {
                    type: 'html',
                    html: `<div class='w-full flex justify-center items-end flex flex-col' style='margin-top: 6px; font-weight: 300;'>
                                資料來源：《世界幸福報告2025》
                            </div><br/><br/>`,
                }
            ]
        }
    ],
    questions: [
        {
            type: "display-text",
            html: '星期五放學後，你和同學子晴、嘉朗到附近的餐廳吃東西。聊天時，子晴提到家人最近都要出差，這幾天只有她一人在家，總覺得有點孤單。嘉朗聽後想起剛才在手機上看到的一篇報章評論，當中提到有些人即使每天與家人一起生活，仍然會感到孤獨。子晴感到有些意外，便請嘉朗把文章轉發到群組，三人一起閱讀。<br/><br/>點擊「下一頁」來閱讀第一個來源。'
        },
        {
            id: '1',
            type: '選擇題',
            question: '1. 文中第二段提到「約有52萬名家庭成員會選擇自我封閉」，這裡的「自我封閉」主要是指甚麼？',
            subtitle: '參考右側的「報章評論」，作答本題。',
            options: [
                { text: 'A. 把心事藏在心裡，不願主動與人交流' },
                { text: 'B. 自己安排生活，盡量不麻煩家人' },
                { text: 'C. 減少參加聚會，避免與家人見面' },
                { text: 'D. 保留自己的想法，不接受網上建議' },
            ],
            tab: 0,
        },
        {
            id: '2',
            type: '選擇題',
            question: '2. 如果為社論第4、5段加上一個小標題，以下哪項最合適？',
            subtitle: '參考右側的「報章評論」，作答本題。',
            options: [
                { text: 'A. 善用科技，取代面對面交流' },
                { text: 'B. 增加共處，提升家庭幸福感' },
                { text: 'C. 改善空間，減少家人間摩擦' },
                { text: 'D. 增加相處，兼顧溝通與空間' },
            ],
            tab: 0,
        },
        {
            id: '3',
            type: '選擇題',
            question: '3. 社論開首先提到，人們談及孤獨時往往想到獨居或缺乏照顧的長者。作者這樣寫的主要作用是甚麼？',
            subtitle: '參考右側的「報章評論」，作答本題。',
            options: [
                { text: 'A. 糾正刻板印象，引出容易被忽略的同住者' },
                { text: 'B. 比較獨居長者和同住成年人的孤獨比例' },
                { text: 'C. 說明缺乏照顧是家庭孤獨的主要成因' },
                { text: 'D. 證明同住者比獨居長者更需要社會支援' },
            ],
            tab: 0,
        },
        {
            type: "display-text",
            html: '讀完文章後，嘉朗望了望桌上的食物，說：「文章建議家人多相處、多交談。那麼，像我們現在這樣一起吃飯，會不會也有幫助？」子晴在網上搜尋相關研究，很快便找到了一篇科普文章。<br/><br/>點擊「下一頁」來閱讀第二個來源。'
        },
        {
            id: '4',
            type: '填寫問題',
            subtitle: '參考右側「科普文章」，作答本題。',
            question_prefix: '4. 根據圖1，一星期與他人共同進餐4至7次的受訪者中，昨日有強烈孤獨感的約佔多少？\n答案：',
            question_postfix: ' %',
        },
        {
            id: '5',
            type: '選擇題',
            question: '5. 嘉朗把圖1五組比例從左到右依次寫成「35%、24%、21%、19%、16%」。以下哪項評價最恰當？',
            subtitle: '參考右側「科普文章」，作答本題。',
            options: [
                { text: 'A. 21%與19%的次序應該互換。' },
                { text: 'B. 次序正確，數值亦屬精確百分比。' },
                { text: 'C. 次序正確，但各數值應保留「約」。' },
                { text: 'D. 首個數值抄錯，35%應為24%。' },
            ],
            tab: 1,
        },
        {
            id: '6',
            type: '表格問題',
            question: '6. 根據科普文章、圖1及表1，判斷以下說法是否正確。每項只選一個答案。',
            subtitle: '參考右側「科普文章」，作答本題。',
            header: ["陳述", "正確", "錯誤"],
            table: [
                { text: '（1）圖1能比較各組強烈孤獨的比例，但不能判斷哪一組人數最多。' },
                { text: '（2）研究只記錄「昨日」的孤獨感，不能反映受訪者一週內的變化。' },
                { text: '（3）香港受訪者平均每週共進晚餐4.4次，即大部分香港人每週共進晚餐4至5次。' },
                { text: '（4）香港午、晚餐的共餐次數都高於日韓，因此香港人較少孤獨。' },
            ],
        },
        {
            id: '7',
            type: '表格問題2',
            question: '7. 社區中心準備試辦親子共餐活動，名額有限，希望優先邀請強烈孤獨感比例最高的一組參加。中心希望活動有助減輕孤獨感，並符合社論建議。根據各來源，以下哪個方案最合適？',
            subtitle: '結合兩個來源，作答本題。',
            table: [
                {
                    title: ' ',
                    rows: [
                        'A',
                        'B',
                        'C',
                        'D'
                    ]
                },
                {
                    title: '邀請對象',
                    rows: [
                        "沒有共餐",
                        "沒有共餐",
                        "每週1至3次",
                        "每週1至3次"
                    ]
                },
                {
                    title: '活動安排',
                    rows: [
                        '各自與AI聊天',
                        '親子交流',
                        '各自與AI聊天',
                        '親子交流',
                    ]
                },
                {
                    title: '效果評估',
                    rows: [
                        '看共餐次數',
                        '比較前後孤獨感',
                        '比較前後孤獨感',
                        '看共餐次數'
                    ]
                }
            ],
        },
        {
            id: '8',
            type: '選擇題',
            question: '8. 嘉朗要為家庭活動分享挑選兩個來源共同支持的內容。請分別查閱報章評論和科普文章，以下哪項最合適？',
            subtitle: '結合兩個來源，作答本題。',
            options: [
                { text: 'A. 與家人一起居住，仍可能感到孤獨。' },
                { text: 'B. 日常人際互動較多，幸福感通常較高。' },
                { text: 'C. 家庭成員自我封閉，不願向親友傾訴。' },
                { text: 'D. 共餐次數較多，生活評分通常較高。' },
            ],
            tab: 1,
        },
        {
            id: '9',
            type: '拖放式問題',
            question: '9. 根據《世界幸福報告2025》研究說明及圖1，把下列選項拖放到表格中的適當位置。',
            subtitle: '參考右側的「科普文章」，作答本題。',
            dragAndDrop: [
                {
                    title: '現象',
                    rows: [
                        { type: "拖放格" },
                        { type: "文字", text: '共餐次數較少的受訪者之間，生活評分差異並不明顯' },
                        { type: "拖放格" },
                    ]
                },
                {
                    title: '可作出的推斷',
                    rows: [
                        { type: "文字", text: '共餐較多者的強烈孤獨感比例較低，兩者可能存在關聯' },
                        { type: "拖放格" },
                        { type: "文字", text: '不能單憑共餐次數判斷孤獨感下降是由共餐直接造成' },
                    ]
                },
            ],
            dragAndDropOptions: [
                { text: 'A. 在香港，與家人同住者，約每五人便有一人感孤獨。' },
                { text: 'B. 共餐次數較少時，生活評分會隨次數增加明顯提高。' },
                { text: 'C. 共餐次數較少時，生活評分未必隨次數增加而上升。' },
                { text: 'D. 沒有共餐者約35%有強烈孤獨感，共餐最多者約16%。' },
                { text: 'E. 較幸福、社交較好的人，可能本就較常與他人共餐。' },
                { text: 'F. 香港平均每週與他人共餐次數多於日本和韓國。' },
            ],
        },
        {
            id: '10',
            type: '短句作答題',
            question: '10. 社論一方面建議家庭成員增加日常相處和交談的時間；另一方面又指出，長時間共處可能帶來更多摩擦。這兩項說法是否矛盾？請根據社論內容進行解釋。',
            subtitle: '參考右側的「報章評論」，作答本題。',
        }
    ]
}
